import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { XCircle, ArrowLeft } from '@phosphor-icons/react';

const PaymentCancel = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const bookingId = searchParams.get('booking_id');

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl p-8 text-center shadow-lg">
        <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle size={48} className="text-red-600" weight="fill" />
        </div>
        <h2 className="text-2xl font-bold text-slate-900 mb-2">Payment Cancelled</h2>
        <p className="text-slate-600 mb-6">
          Your payment was cancelled. Don't worry, you haven't been charged.
        </p>

        <div className="space-y-3">
          {bookingId && (
            <Button 
              onClick={() => navigate(`/bookings`)}
              className="w-full bg-blue-500 hover:bg-blue-600 rounded-xl h-12"
            >
              Try Payment Again
            </Button>
          )}
          <Button 
            onClick={() => navigate('/buyer')}
            variant="outline"
            className="w-full rounded-xl h-12"
          >
            <ArrowLeft size={18} className="mr-2" />
            Back to Home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
